<template>
<div>
  <div class="row">
    <div class="col-sm-12 col-md-12 breadcrumb-side-button">
      <div class="float-md-right mb-3">

        <el-tooltip
          placement="top"
          :effect="themeMode.darkMode == true ? 'light' : 'dark'"
          :content="$t('print_detail')">
          <button
            type="button" 
            @click.prevent="generateReport" 
            class="btn btn-primary btn-sm">Print</button>
        </el-tooltip>

      </div>
      <div class="float-md-left mb-3">
        <button
            type="button"
            class="btn btn-primary btn-md"
            data-toggle="modal"
            @click="showLogBookForm">Log Event
          <!-- {{ $t("instruction") }} -->
          <app-icon :name="iconClass"/>

        </button>
      </div>
    </div>

    </div>
    <div v-if="displayForm" class="col-12 mb-primary">

        <div class="card card-with-shadow border-0 h-100">
          <app-overlay-loader v-if="preloader"/>
          <div class="card-body">
            <form ref="form" :data-url="siteLogUrl" class="mb-0" :class="{'loading-opacity': preloader}">

              <div class="form-group row align-items-center">
                <label for="event_type" class="col-sm-2 mb-sm-0">
                  {{ $t('event_type') }}
                </label>
                <app-input class="col-sm-8"
                           type="select"
                           v-model="inputs.event_type"
                           :list="eventTypes"
                           :placeholder="$t('event_type')"/>

              </div>

              <div class="form-group row align-items-center">
                <label for="event_detail" class="col-sm-2 mb-sm-0">
                  {{ $t('event_detail') }}
                </label>
                <app-input id="textarea_field"
                           class="col-sm-8"
                           type="textarea" required
                           :placeholder="$t('event_detail')"
                           v-model="inputs.event_detail"/>
              </div>
              <div class="form-group row align-items-center">
                <label for="event_status" class="col-sm-2 mb-sm-0">
                  {{ $t('event_status') }}
                </label>
                <app-input class="col-sm-8"
                           type="select"
                           v-model="inputs.event_status"
                           :list="eventStatus"
                           :placeholder="$t('event_status')"/>
              </div>
              <div class="form-group row align-items-center">
                <label for="severity" class="col-sm-2 mb-sm-0">
                  {{ $t('severity') }}
                </label>
                <app-input class="col-sm-8"
                           type="select"
                           v-model="inputs.severity"
                           :list="severity"
                           :placeholder="$t('severity')"/>
              </div>


              <div class="form-group row align-items-center">
                <label for="event_recorded_at" class="col-sm-2 mb-sm-0">
                  {{ $t('event_recorded_at') }}
                </label>
                <app-input class="col-sm-3"
                           type="date"
                           v-model="inputs.event_recorded_at"
                           :placeholder="$t('select_valid_date')"/>
                <app-input class="col-sm-3"
                           type="time"
                           v-model="inputs.time_picker"
                           :placeholder="$t('select_valid_time')"/>

              </div>

              <div class="mt-5 action-buttons">
                <button type="submit" class="btn btn-primary mr-2" @click.prevent="submit">
                  {{ $t('submit') }}
                </button>
                <button type="submit" class="btn btn-secondary" @click.prevent="clear">
                  {{ $t('clear') }}
                </button>
              </div>
            </form>
          </div>

          </div>
        </div>
  <VueHtml2pdf
      :show-layout="false"
      :float-layout="false"
      :enable-download="true"
      :preview-modal="false"
      :paginate-elements-by-height="2400"
      :filename="pageTitle"
      :pdf-quality="2"
      :manual-pagination="false"
      pdf-format="a4"
      pdf-orientation="landscape"
      pdf-content-width="100%"
      ref="html2Pdf">
    <section slot="pdf-content">
      <div class="card card-with-search border-0 card-with-shadow">
        <div class="card-header d-flex align-items-center p-primary bg-transparent">
          <h5 class="card-title d-inline-block mb-0">Site Information:</h5>
        </div>
        <div class="card-body">
          <div class="text-justify">
            <h6>Site Title: {{sharedData.sharedData.siteData.title}} <span></span> Assignment Structure: {{sharedData.sharedData.siteData.assignment_structure}} </h6>
            <h6>Starting Hours: {{sharedData.sharedData.siteData.starting_hours}}  <span></span>Ending Hours: {{sharedData.sharedData.siteData.ending_hours}} </h6>
          </div>
        </div>
        <app-table :id="tableId" :options="options" @action="getListAction" />
      </div>

    </section>
  </VueHtml2pdf>
</div>
</template>
    

<script>

import {TableHelpers} from "../../../../Demo/Tables/mixins/TableHelpers";
import CoreLibrary from "../../../../../../../core/helpers/CoreLibrary.js";
import {
  SITE_LOGS,
  SITE_LOGS_LIST, SITE_LOGS_DATA
} from "../../../../../../Config/ApiUrl.js";
import {axiosGet} from "../../../../../../Helpers/AxiosHelper.js";
import {FormMixin} from "@/core/mixins/form/FormMixin";

import GlobalHelperMixin from "@/app/Mixins/global/GlobalHelperMixin";
import AppLibrary from "@/app/Helpers/AppLibrary";
import { mapState } from 'vuex';

export default {
    extends: CoreLibrary,
    mixins: [GlobalHelperMixin, FormMixin, AppLibrary, TableHelpers],
  props:{
      siteId: Number,
  },
  data() {
    return {
      instructionShow: false,
      bgStyle: true,
      isTaskReminderModalActive: false,
      classRemove: true,
      displayForm: false,
      preloader: false,
      eventTypes: {},
      eventStatus: {},
      severity:{},
      siteLogUrl: SITE_LOGS+ '/' + this.$attrs['props'].siteId,
      inputs:{},
      iconClass: 'plus-circle',
      active: 1,
      task_id: 0,
      tableId: "advance-table",
      rowData: {},
      pageTitle: 'SiteLogBook',
      options: {
        name: "AdvanceTable",
        url: SITE_LOGS_LIST+ '/' + this.$attrs['props'].siteId,
        // url: actions.DATATABLE_DATA,
        showHeader: true,
        columns: [
            {
                title: this.$t("event_type"),
                type: "custom-html",
                key: "event_type",
                modifier: (value) => {
                  return `<span>${value}</span>`;
                }
            },
          {
            title: this.$t("severity"),
            type: "custom-html",
            key: "severity",
            modifier: (value) => {
              return `<span>${value}</span>`;
            }
          },

            {
                title: this.$t("event_detail"),
                type: "custom-html",
                key: "event_detail",
                modifier: (value) => {
                return `<span>${value}</span>`;
                },
            },
            {
                title: this.$t("event_recorded_at"),
                type: "custom-html",
                key: "event_recorded_at",
                modifier: (value, row) => {
                  if (value){
                    let event_time = moment(value).format("D/M/Y h:mm A");
                    return `<span>${this.$t(event_time)}</span>`;

                  }else {
                    value = row.created_at
                    let event_time = moment(value).format("D/M/Y h:mm A");
                    return `<span>${this.$t(event_time)}</span>`;

                  }
                },
            },

            {
              title: this.$t("event_status"),
              type: "custom-html",
              key: "event_status",
              modifier: (value) => {
                return `<span>${value}</span>`;
              }
            },
          {
            title: this.$t("site_user"),
            type: "custom-html",
            key: "users",
            modifier: (value,row) => {

              return `<span>${value?.full_name } </span>`;
            }
          }
        
        ],
        // actions: [
        //   {
        //     title: this.$t("view"),
        //     icon: "eye",
        //     type: "none",
        //   },
        // ],
        filters: [
          {
            "title": this.$t('Date Range'),
            "type": "range-picker",
            "key": "date",
            "option": ["today", "thisMonth", "last7Days", "thisYear"]
          },
            {
            title: this.$t("search_and_select"),
            type: "drop-down-filter",
            key: "search select",
            option: [],
          },
        ],
        showFilter: true,
        showSearch: true,
        showCount: true,
        showClearFilter: true,
        paginationType: "pagination",
        responsive: true,
        rowLimit: 30,
        showAction: false,
        orderBy: "desc",
        actionType: "dropdown",
      },
    };
  },
  created() {
    this.options.columns = [...this.options.columns, this.actionObj];
    this.searchAndSelectFilterOptions();
  },
  computed: {
    ...mapState(['sharedData']),
      userRole() {
        return this.$store.state.user.loggedInUser;
      },
      themeMode() {
        return this.$store.state.theme;
      },

   },
  methods: {
    generateReport(){
      this.$toastr.s('PDF generation is in progress, Please wait.');
      this.$refs.html2Pdf.generatePdf();
    },
    getListAction(rowData, actionObj, active) {
      this.rowData = rowData;
    },
    showLogBookForm(){
      let show = this.displayForm
      show ? this.iconClass = 'minus-circle': this.iconClass = 'plus-circle'
      show ? this.displayForm = false: this.displayForm = true
    },
    beforeSubmit() {
      this.preloader = true;
    },
    submit() {

      if (this.inputs.event_recorded_at) this.inputs.event_recorded_at = this.getDateFormatForBackend(this.inputs.event_recorded_at);
      this.save(this.inputs);
    },
    afterSuccess(res) {
      this.$toastr.s(res.data.message);
    },
    afterFinalResponse() {
      this.preloader = false;
      this.inputs = {};
    },
    afterError(res) {
      this.$toastr.e(res.data.message);
    },
    clear() {
      this.inputs = {};
    },
    getListValues() {
      axiosGet(SITE_LOGS_DATA + "/" + this.$attrs['props'].siteId).then((response) => {
        this.idsToValues = response.data.ids_to_values;
        this.eventStatus =  response.data.event_status;
        this.severity =  response.data.severity;
        this.eventTypes =  response.data.event_types;
      });
    },

    searchAndSelectFilterOptions() {
      let name = this.options.filters.find(
          (element) => element.title === this.$t("search_and_select")
      );
     name.option =[
       { id:0, value: 'Checkin/Checkout'},
       { id:1, value: 'Checkin' },
       { id:2, value: 'Checkout' },
       { id:3, value: 'Visit' },
       { id:4, value: 'Check-Call'},
       { id:5, value: 'Petrol'},
     ]
    },
  },
  mounted() {
      this.getListValues();
     $("#removeclass .modal-dialog ").removeClass("modal-dialog-scrollable");

  },
};
</script>
